import { render } from "./entrance.vue?vue&type=template&id=b778b66c"
import script from "./entrance.vue?vue&type=script&lang=js"
export * from "./entrance.vue?vue&type=script&lang=js"

import "./entrance.vue?vue&type=style&index=0&id=b778b66c&lang=scss"

import exportComponent from "E:\\project\\code\\gitLab\\zhinong\\ah_home_page_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__